import { render, staticRenderFns } from "./ExtraFieldsEditText.vue?vue&type=template&id=57da4b7e"
import script from "./ExtraFieldsEditText.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsEditText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports